<template>
  <div>
    <div style="height: 54px" class="sub-nav-box-1">
      <!-- judul halaman -->
      <h2>Daftar Kategori</h2>
    </div>
    <!-- main view halaman -->
    <div style="margin-top: 70px; background: none" class="main-view">
      <DaftarKategori />
    </div>
    <!-- end of main view halaman -->
  </div>
</template>

<script>
import DaftarKategori from "@/components/finance/bukuKas/DaftarKategori";
import { mapState } from "vuex";

export default {
  created() {
    // kalau bukan manager langsung dialihkan ke page buku-kas
    if (this.userData.jabatan === "pegawai") this.$router.push("buku-kas");
  },

  components: {
    DaftarKategori,
  },
  computed: {
    ...mapState(["userData"]),
  },
};
</script>
